import { RootState } from 'store/store.types';
import { DetailsRequest } from 'gql/autogen/DetailsRequest';
import { InternalContext } from 'gql/autogen/InternalContext';
import { ActivityGqlOperation, DetailsRequestProps, GqlLogTags } from 'store/api/api.types';
import { getGeoLogTags } from 'core/service/measurements/measurementUtils';
import { imageRequestData, imageRequestDataType } from 'gql/activityBuilder/details/variables/variablesConstant';
import { ExperimentId } from 'core/type/ExperimentId';
import { isB } from 'core/window/bootstrapConfig';

interface ImageRequest {
    count: number;
    width: number;
    height: number;
}

const getImageRequestData = (state: RootState, props: DetailsRequestProps): ImageRequest => {
    const { mobile, desktop, tablet } = state?.screen?.screenSize || {};
    const useDesktopRatio = isB(ExperimentId.ACT_5038, state.bootstrap.config.experiments);
    let imageConfig = imageRequestDataType.DESKTOP;

    if (desktop) {
        imageConfig = useDesktopRatio ? imageRequestDataType.DESKTOP_V2 : imageRequestDataType.DESKTOP;
    } else if (tablet) {
        imageConfig = imageRequestDataType.TABLET;
    } else if (mobile) {
        imageConfig = imageRequestDataType.MOBILE;
    }
    return imageRequestData[imageConfig];
};

const build = (state: RootState, props: DetailsRequestProps, context: InternalContext): DetailsRequest => {
    const { activityId, loyaltySearchType } = props;
    const imageRequest = getImageRequestData(state, props);

    return {
        context,
        contentRequest: {
            imageRequest,
        },
        detailsRequest: {
            activityId,
            loyaltySearchType,
        },
    };
};

export const buildLogTags = (state: RootState, variables: Record<string, unknown>): GqlLogTags => {
    const request = (variables as unknown as { DetailsRequest: DetailsRequest }).DetailsRequest.detailsRequest;
    const geoTags = getGeoLogTags(state.bootstrap.config);
    return {
        ...geoTags,
        operation: ActivityGqlOperation.details,
        activityId: String(request.activityId),
    };
};

export default build;
